import React from 'react'
import styled from 'styled-components'
import { BrowserRouter as Router, Route, Link } from 'react-router-dom'
import Channel from './Channel'

import icon from './icon.svg'

function App() {
  return (
    <Router>
      <Container>
        <Navigation>
          <ul>
            <li>
              <img src={icon} width={15} />
              <NavText>Compose</NavText>
            </li>
            <li>
              <Link to="/">
                <img src={icon} width={15} /> <NavText>Newsfeed</NavText>
              </Link>
            </li>
            <li>
              <img src={icon} width={15} /> <NavText>Discovery</NavText>
            </li>
            <li>
              <img src={icon} width={15} /> <NavText>Minds+</NavText>
            </li>
            <li>
              <img src={icon} width={15} /> <NavText>Wallet</NavText>
            </li>
            <li>
              <img src={icon} width={15} /> <NavText>Boost</NavText>
            </li>
            <li>
              <img src={icon} width={15} /> <NavText>Earn</NavText>
            </li>
            <li>
              <img src={icon} width={15} /> <NavText>Refer</NavText>
            </li>
            <li>
              <img src={icon} width={15} /> <NavText>Buy Tokens</NavText>
            </li>
            <li>
              <Link to="/channel">
                <img src={icon} width={15} />{' '}
                <NavText>@michaelfbradley</NavText>
              </Link>
            </li>
            <li>
              <img src={icon} width={15} /> <NavText>More</NavText>
            </li>
          </ul>
        </Navigation>

        <div style={{ overflowY: 'scroll', width: '100%' }}>
          <Route path="/grid">
            <Content>
              <Grid>
                {Array.from(Array(100).keys()).map((item) => (
                  <GridItem>
                    <GridItemContent>
                      Post #{item}{' '}
                      <img
                        src="https://source.unsplash.com/random/300x300"
                        width="100%"
                      />
                    </GridItemContent>
                  </GridItem>
                ))}
              </Grid>
            </Content>
          </Route>

          <Route path="/channel">
            {/* <Content> */}
            <Channel />
            {/* </Content> */}
          </Route>

          <Route path="/" exact={true}>
            <Content>
              <Newsfeed>
                {ITEMS.map((item, index) => (
                  <NewsfeedItem>
                    <NewsfeedItemHeader>{item.author}</NewsfeedItemHeader>
                    <NewsfeedItemContent>
                      <img
                        src="https://source.unsplash.com/random"
                        width="100%"
                      />
                    </NewsfeedItemContent>
                  </NewsfeedItem>
                ))}
              </Newsfeed>

              <Sidebar>
                <SidebarComponent>
                  Onboarding
                  <ul>
                    <li>Do this...</li>
                    <li>Do that</li>
                  </ul>
                </SidebarComponent>
                <SidebarComponent>
                  Channels you might like
                  <ul>
                    <li>Do this...</li>
                    <li>Do that</li>
                  </ul>
                </SidebarComponent>
                <SidebarComponent>
                  Interesting groups
                  <ul>
                    <li>Do this...</li>
                    <li>Do that</li>
                  </ul>
                </SidebarComponent>
              </Sidebar>
            </Content>
          </Route>
        </div>
      </Container>
    </Router>
  )
}

export default App

const Container = styled.div`
  display: flex;
  max-width: 2560px;
  margin: 0 auto;
  height: 100vh;
  color: #fff;

  @media screen and (min-width: 2560px) {
    border-right: 1px solid #404e53;
    border-left: 1px solid #404e53;
  }
`
const Navigation = styled.nav`
  flex-basis: 20%;
  max-width: 300px;
  flex-shrink: 0;
  border-right: 1px solid #404e53;

  ul {
    padding: 20px;
    margin: 0;
    li {
      list-style: none;
      padding: 1vh 0;
      margin: 0;
      font-size: 20px;
      font-weight: bold;
      cursor: pointer;

      &:hover {
        color: yellow;
      }
    }
  }
`

const NavText = styled.span`
  @media only screen and (max-width: 900px) {
    display: none;
  }
`

const Content = styled.div`
  flex-basis: 75%;
  display: flex;
  padding: 1vw;
`

const Newsfeed = styled.div`
  flex-basis: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;
  padding: 15px;
`

const NewsfeedItem = styled.div`
  max-width: 600px;
  border-radius: 1px;
  border: 1px solid #414c57;
  margin: 1vh 0;
`

const NewsfeedItemHeader = styled.div`
  padding: 5px;
`

const NewsfeedItemContent = styled.div`
  // background: orange;
`

const Sidebar = styled.div`
  flex-grow: 1;
  padding: 15px;
`

const SidebarComponent = styled.div`
  border: 1px solid #414c57;
  border-radius: 5px;
  padding: 10px;
  margin: 3vh 0;
`

const Grid = styled.div`
  overflow-y: scroll;
  display: flex;
  flex-wrap: wrap;
  flex-basis: 100%;
  flex-grow: 1;
`

const GridItem = styled.div`
  width: calc(100% / 4);

  @media only screen and (min-width: 1000px) {
    width: calc(100% / 4);
  }

  @media only screen and (min-width: 1300px) {
    width: calc(100% / 5);
  }

  @media only screen and (min-width: 1500px) {
    width: calc(100% / 6);
  }
`
const GridItemContent = styled.div`
  padding: 10px;
  hegiht: 100%;
`

const ITEMS = [{ author: 'Jim' }, { author: 'Ted' }, { author: 'Mia' }]
